'use strict';

/**
 * @module  common.filters.GroupRole
 *
 * Convert an integer value (1, 10, 50) into human readable form
 */

function GroupRole () {
  return function (input) {
    
    var levels = {
      0: 'Disabled',
      10: 'Member',
      50: 'Admin'
    };

    return levels[input] || input;
  };
}

module.exports = GroupRole;


// WEBPACK FOOTER //
// ./src/common/filters/GroupRole.js